import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import {Item} from '@/components/core';
import Pager from '../_common/pager';
import mock from '../_data/join'


const adapter = (item) => {
  return {
    title: {title: item.title, itemClass: 'item-title'},
    body: [
      { title: item.address },
      { title: item.positionTypeName },
    ],
    dot: [
      item.duties && {
        title: {title: '岗位职责：', itemClass: 'item-subtitle'},
        dot: [{ title: <pre>{item.duties}</pre>, itemClass: 'item-content'}]
      },
      item.ask && {
        title: {title: '岗位要求：', itemClass: 'item-subtitle'},
        dot: [{ title: <pre>{item.ask}</pre>, itemClass: 'item-content'}]
      },
      item.pluses && {
        title: {title: '加分项：', itemClass: 'item-subtitle'},
        dot: [{ title: <pre>{item.pluses}</pre>, itemClass: 'item-content'}]
      },
      { title: '请投递简历至：hr@mingxinsk.com', itemClass: 'mt-default' }
    ]
  }
}
const itemCfg = {
  attached() {
    // console.log(this, 'attached')
  },
  bodyClass: 'item-type',
  itemClass: 'item-detail',
  ready() {
    const id = window.location.search.split('id=')[1]
    const getData = mock.filter(item => item.id === id)
    document.getElementsByTagName("title")[0].innerText = '深圳市明心数智科技有限公司-' + getData[0].title;
    const data = adapter(getData[0])
    this.reset(data)
  }
}

const PagesBody = props => {
  return (
    <div className="wid1200 pages-join-detail-wrap">
      <Item {...itemCfg} />
    </div>
  )
}

const cfg = {
  banner: {
    data: [
      {
        img: '/images/about/join.jpg',
        showButton: false,
        content: {
          title: '加入我们',
          desc: '和优秀的人，做有挑战的事',
          className: 'color-fff'
        }
      }
    ]
  },
  body: <PagesBody />
}
const App = () => (
  <Pager {...cfg} />
);

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)